export default "__VITE_ASSET__BuMHTOky__"